import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { el } from 'date-fns/locale';
import { ICandidate, IExam, IExaminationSchedule } from 'src/app/interface/dto';
import { examinationScheduleDefault } from 'src/app/interface/dtoDefaults';
import { ExamScheduleService } from 'src/app/services/exam-schedule-service';
import { ExamService } from 'src/app/services/exam-service.service';
import { SnackbarService } from 'src/app/services/snackbar.service';
import { Util } from 'src/app/services/Util';
import { debounceTime, distinctUntilChanged, firstValueFrom, of, Subject, switchMap } from 'rxjs';
import { GridUtil } from 'src/app/components/grid/GridUtil';
import { CandidateService } from 'src/app/services/candidate-service.service';
import { TableMode } from 'src/app/components/grid/grid.component';
import { ITableData } from 'src/app/components/grid/ITableData';
import { QueryOperand } from 'src/app/components/grid/QueryOperand';
import { ElementRef, ViewChild, HostListener } from '@angular/core';
import { AuthService } from 'src/app/services/http-services/authservice.service';

@Component({
  selector: 'app-veiw-schedule',
  templateUrl: './veiw-schedule.component.html',
  styleUrls: ['./veiw-schedule.component.scss']
})
export class VeiwScheduleComponent implements OnInit {


  examSchedule: IExaminationSchedule = examinationScheduleDefault;
  disableAll: boolean = true;
  mode = "";
  selectedExam: any;
  examList: Array<IExam>;
  examFromId: number;
  isFromCandidate = false;
  searchResults: any[];
  private searchSubject = new Subject<string>();
  @ViewChild('lookupContainer') lookupContainer!: ElementRef;

  showLookup = false;

  constructor(private snackBar: SnackbarService, private actRoute: ActivatedRoute, private examSchService: ExamScheduleService,
    private router: Router, private examService: ExamService, private candidateServices: CandidateService,private authService: AuthService) { }

  @HostListener('document:click', ['$event'])
  onClickOutside(event: MouseEvent) {
    if (!this.lookupContainer?.nativeElement.contains(event.target)) {
      this.closeLookup();
    }
  }
  async ngOnInit() {
    try {
      const queryParams = await firstValueFrom(this.actRoute.queryParams);
      this.mode = queryParams['mode'] || '';
      if (queryParams['examschid']) {
        const id = parseInt(queryParams['examschid']);
        const res: any = await this.examSchService.getScheduleDetails(id);
        if (res) {
          this.examSchedule = res;
          const localStartDate = Util.convertUTCToTimezone(this.examSchedule.startDateTime, this.authService.user.timezoneOffset);
          this.examSchedule.startDateTime = Util.toLocalInputValue(localStartDate) as any;
          const localSEndDate = Util.convertUTCToTimezone(this.examSchedule.endDateTime, this.authService.user.timezoneOffset);
          this.examSchedule.endDateTime = Util.toLocalInputValue(localSEndDate) as any;
          const localActualStartDate = Util.convertUTCToTimezone(this.examSchedule.actualStartDateTime, this.authService.user.timezoneOffset);
          this.examSchedule.actualStartDateTime = Util.toLocalInputValue(localActualStartDate) as any;
          const localActualEndDate = Util.convertUTCToTimezone(this.examSchedule.actualEndDateTime, this.authService.user.timezoneOffset);
          this.examSchedule.actualEndDateTime = Util.toLocalInputValue(localActualEndDate) as any;

        }
      } else {
        const localStartDate = Util.convertUTCToTimezone(this.examService.selectedExams[0].examStartDate, this.authService.user.timezoneOffset);
        this.examSchedule.startDateTime = Util.toLocalInputValue(localStartDate) as any;
        const localSEndDate = Util.convertUTCToTimezone(this.examService.selectedExams[0].examEndDate, this.authService.user.timezoneOffset);
        this.examSchedule.endDateTime = Util.toLocalInputValue(localSEndDate) as any;
      }
      if (queryParams['isFromCandidate']) {
        await this.examService.getAllExams().then((exams: any) => {
          this.examList = exams;
        })
        const selectedCandidate = this.candidateServices.selectedCandidates[0];
        this.isFromCandidate = queryParams['isFromCandidate'] as boolean;
        console.log(selectedCandidate, "Selected Candidate");
        this.examSchedule.examNo = selectedCandidate.examNo;
      }


      if (this.mode == 'view-all') {
        this.disableAll = true;
      } else if (this.mode == 'edit' || this.mode == 'copy' || this.mode == 'add') {
        this.disableAll = false;
        
        if (this.mode == 'copy' || this.mode == 'add') {
          if (this.mode == 'copy') {
            this.examSchedule = this.examSchService.selectedSchedules[0];
            this.examSchedule.examinationID = this.examService.selectedExamIds[0];
          }
          this.examSchedule.id = 0; // Reset ID for new schedule creation
          this.examSchedule.examNo = '';
          this.examSchedule.status = 'Pending';
          this.examSchService.selectedSchedules = [];
          this.examSchService.selectedIds = [];
        }
       

      }
      if (this.examSchedule.status == 'InProgress' && this.mode == 'edit') {
        this.disableAll = true;
      }
      this.searchSubject
        .pipe(
          debounceTime(300),
          distinctUntilChanged(),
          switchMap(q =>
            q.length >= 3
              ? this.candidateServices.getCandidateLookup({ examNo: q }).catch(err => {
                console.error('ExamNo lookup failed', err);
                return [];
              }) : of([])
          )
        )
        .subscribe((result: any[]) => {
          // Update the UI with the search results returned (ExamNo only)
          this.searchResults = result;
          this.showLookup = result.length > 0;

        });
    } catch (err) {
      console.error('Error in ngOnInit:', err);
    }
  }
  saveSchedule() {
    try {
      if (this.mode == 'copy' || this.mode == 'add') {
        if (this.isFromCandidate && !this.examFromId) {
          this.snackBar.error('Please select an examination to schedule for ');
          return;
        }
        let examid = this.isFromCandidate ? this.examFromId : this.examService.selectedExamIds[0];
        this.examSchedule.id = 0;
        this.examSchedule.examinationID = examid;
        this.examSchService.addSchedule(this.examSchedule).then((res: any) => {
          if (res) {
            this.snackBar.success('Schedule Added successfully');
            GridUtil.setClearGridSelection();
            this.router.navigate([`exams/${examid}/schedules`]);
            this.examSchService.reloadGrid.next(true);
          }
        }).catch(error => {
          this.snackBar.error('Error while adding schedule: ' + error);
          console.error('Error while adding schedule', error);
        });
        return;
      }
      this.examSchService.saveScheduleDetails(this.examSchedule).then((res: any) => {
        if (res) {
          this.snackBar.success('Schedule saved successfully');
          this.router.navigate([`exams/${this.examService.selectedExamIds[0]}/schedules`]);
          this.examSchService.reloadGrid.next(true);
        }
      });
    } catch (error) {
      this.snackBar.error('Error while saving schedule');
      console.error('Error while saving schedule', error);
    }
  }
  cancel() {
    window.history.back();
  }


  onExamNoChange(value: string) {
    this.searchSubject.next(value);
  }

  selectExamNo(examNo: string) {
    this.examSchedule.examNo = examNo;
    this.closeLookup();
  }
  openLookup() {
    this.showLookup = true;
  }

  closeLookup() {
    this.showLookup = false;
  }
}
